import { NgModule } from '@angular/core';
import { ButtonModule } from '@components/button/modules/button.module';
import { ImageCropperModule } from 'ngx-image-cropper';
import { GlobalModule } from '../../core/global.module';
import { CropperDialogComponent } from './cropper-dialog.component';

@NgModule({
    declarations: [CropperDialogComponent],
    imports: [GlobalModule, ButtonModule, ImageCropperModule],
})
export class CropperDialogModule {}
